import React from 'react'
import { Grid, Row, Col } from 'react-bootstrap'
import { AmbassadorSection } from '../../../../../../../Components/City/Page/Ambassador/AmbassadorSection'
import { SectionTitle } from '../../../../../../../Components/Section/SectionTitle'
import { FiltersWrapper } from '../../../../../../../Components/Filter/FiltersWrapper'
import { FilterBox } from '../../../../../../../Components/Filter/FiltersWrapper/box'
import { FilterSelect } from '../../../../../../../Components/Filter/FilterSelect'
import { Table } from '../../../../../../../Components/Table'
import { Th } from '../../../../../../../Components/Table/Th'
import { Tr } from '../../../../../../../Components/Table/Tr'
import { Td } from '../../../../../../../Components/Table/Td'
import * as CONST from '../../../../../../../Reducers/Ambassador/const'
import { Ticked } from '../../../../../../../Components/Ticked'

const MerchandiseSectionView = ({
  ambassadorInventory,
  ambassadorInventoryClients,
  onChangeFilterByClient,
  clientId,
  onChangeSort,
  isPickUp,
  isDropOff,
}) => {
  return (
    <AmbassadorSection className="no-padding">
      <Grid fluid>
        <Row className="padding-row">
          <Col xs={12}>
            <SectionTitle>Merchandise</SectionTitle>
            {ambassadorInventory.length > 0 && (
              <FiltersWrapper className="merchandise-filter">
                <FilterBox className="filter-box align-right">
                  <FilterSelect
                    hasPrimaryText={true}
                    primaryText="All"
                    className="select-status"
                    label="Client"
                    options={ambassadorInventoryClients}
                    onChange={onChangeFilterByClient}
                    value={clientId}
                    sorted={true}
                  />
                </FilterBox>
              </FiltersWrapper>
            )}
          </Col>
        </Row>
        {ambassadorInventory.length ? (
          <Row>
            <Col xs={12} className="full-width-table">
              <Table>
                <thead>
                  <Tr>
                    <Th
                      className="sortable sortable col-xs-5"
                      onClick={() =>
                        onChangeSort(CONST.DATA_TYPES.INVENTORY, 'client')
                      }
                    >
                      Client
                    </Th>
                    <Th
                      className="centered sortable"
                      onClick={() =>
                        onChangeSort(CONST.DATA_TYPES.INVENTORY, 'type')
                      }
                    >
                      Type
                    </Th>
                    <Th
                      className="centered sortable col-xs-3"
                      onClick={() =>
                        onChangeSort(CONST.DATA_TYPES.INVENTORY, 'quantity')
                      }
                    >
                      Quantity
                    </Th>
                    <Th className="align-right pick-up-th fitWidth">Pick Up</Th>
                    <Th className="align-right fitWidth">Drop off</Th>
                  </Tr>
                </thead>
                <tbody>
                  {ambassadorInventory.map(inventory => (
                    <Tr key={inventory.id}>
                      <Td className="col-xs-5">
                        <p>{inventory.client.name}</p>
                      </Td>
                      <Td className="centered">
                        <p>{inventory.type.name}</p>
                      </Td>
                      <Td className="centered col-xs-3">
                        <p>{inventory.quantity}</p>
                      </Td>
                      <Td className="align-right">
                        <Ticked ticked={isPickUp(inventory.comments)} />
                      </Td>
                      <Td className="align-right">
                        <Ticked ticked={isDropOff(inventory.comments)} />
                      </Td>
                    </Tr>
                  ))}
                </tbody>
              </Table>
            </Col>
          </Row>
        ) : (
          <p className="not-found">No merchandise held</p>
        )}
      </Grid>
    </AmbassadorSection>
  )
}

export default MerchandiseSectionView



// WEBPACK FOOTER //
// ./src/Containers/City/Page/Ambasador/Components/MerchandiseSection/component/MerchandiseSectionView.js